<mat-card class="filter settingHeader" *ngIf="!payCheck">
    <div class="name">
        Add 3rd Party applications
    </div>

    <div class="quickAction" *ngIf="ShowSuperAdmin">
    <button mat-flat-button color="primary" (click)="addNewApplication(addNew)"> Add New </button>
    </div>
  
  </mat-card>

    
  <div class="oneblk" *ngIf="!payCheck">
  
    <mat-card class="impBlock"  *ngFor="let app of thirdPartyApplicationList">
      <img src="{{app.apiLogo}}" (click)="showDetailLogo(app)" alt="">
     
     
      <div class="detail">     
        <span (click)="showDetail(app)">{{app.thirdPartyApiName}}</span>       
        <p (click)="showDetail(app)">{{app.apiDescription}}</p>
      <div class="actions">
        <!-- <button *ngIf="app.apiAuthDetail!=null && app.isAuth==true" mat-icon-button color="basic"  matTooltip="Get Authenticate" matTooltipClass="tooltip"><mat-icon>verified</mat-icon></button> -->
       
        <button *ngIf="!ShowSuperAdmin && !app?.apiAuthDetail?.isRequestclientAccessed" mat-icon-button color="basic"  matTooltip="Access Not Granted" matTooltipClass="tooltip"><mat-icon>verified</mat-icon></button>
        <button *ngIf="!ShowSuperAdmin && app?.apiAuthDetail?.isRequestclientAccessed"  mat-icon-button color="basic"  matTooltip="Access Granted" matTooltipClass="tooltip"><mat-icon style="color:#24e824">verified</mat-icon></button>
        
        <button *ngIf="!ShowSuperAdmin && app.thirdPartyApiName=='PointClickCare'" mat-icon-button color="basic"  (click)="GetFacilities(app,GetFacilitiespopup)" matTooltip="View Facilities" matTooltipClass="tooltip"><mat-icon>pregnant_woman</mat-icon></button>
        
        <button *ngIf="!ShowSuperAdmin && app.thirdPartyApiName=='PointClickCare'" mat-icon-button color="basic"  (click)="openDialogWithRef(app,myDialog)" matTooltip="Add PointClickCare Organization ID" matTooltipClass="tooltip"><mat-icon>add</mat-icon></button>
        <button *ngIf="!ShowSuperAdmin && app.thirdPartyApiName!='PointClickCare'" mat-icon-button color="basic" (click)="openDialogWithRef(app,myDialog)" matTooltip="Request Access" matTooltipClass="tooltip"><mat-icon>add</mat-icon></button>
        
        <button *ngIf="ShowSuperAdmin" mat-icon-button color="basic" (click)="openSuperDialogWithRef(app,myDialog)" matTooltip="Add/Edit API Credentials" matTooltipClass="tooltip"><mat-icon>add</mat-icon></button>
        <button mat-icon-button color="basic" (click)="authenticateAPiEndPoint(app)"  matTooltip="API End Points" matTooltipClass="tooltip"><mat-icon>assignment_add</mat-icon></button>
        <button *ngIf="app.thirdPartyApiName=='Paychex' && !ShowSuperAdmin" mat-icon-button color="basic" (click)="SyncAllWorker(app)"  matTooltip="Sync All Worker" matTooltipClass="tooltip"><mat-icon>sync</mat-icon></button>
        <button *ngIf="ShowSuperAdmin" mat-icon-button color="basic" (click)="updateNewApplication(updateNew,app)" class="ml-auto" matTooltip="Edit Application Detail" matTooltipClass="tooltip"><mat-icon>edit_square</mat-icon></button>
        <button *ngIf="ShowSuperAdmin" mat-icon-button (click)="deleteApplication(app)"> <mat-icon>delete</mat-icon></button>
      </div>

      </div>

    </mat-card>  
       
  </div>
  
  
  <div class="documents" *ngIf="payCheck">
  
    <mat-card class="filter settingHeader">
      <div class="name">
        <button mat-icon-button color="primary" style="margin-left: 0;" (click)="fieldLostPopup(fieldLostWarningPopup,3,'',1000)"><mat-icon>arrow_back</mat-icon></button> 
        {{thirdPartyName}}
      </div>
       
      <div class="quickAction" *ngIf="!ShowSuperAdmin">
        <mat-form-field>
          <mat-label>Add API's</mat-label>
          <mat-select [(ngModel)]="addThirdPartyEndpointID"  class="custom-select-style" (selectionChange)="selectAPI($event)" >               
            <mat-option *ngFor="let api of thirdPartyApiEndpointsList" [value]="api.thirdPartyEndpointID">
            {{ api.endpointName }}
            </mat-option>
          </mat-select>
        </mat-form-field>          
      </div>

     
      <button  *ngIf="ShowSuperAdmin" mat-flat-button color="primary" style="margin-left: 10px" (click)="addNewEndPoint(addEndPoint)">Add</button>
      <button  *ngIf="!ShowSuperAdmin" [disabled]="addThirdPartyEndpointID==0" mat-flat-button color="primary" style="margin-left: 10px" (click)="addNewOfficeEndPoint(addEndPoint)">Add</button>
          
    </mat-card>
  
 
  
    <mat-card *ngIf="ShowSuperAdmin" class="apiListHolder">
      <div class="allApi">
        <ul>
          <ng-container *ngFor="let app of thirdPartyApiEndpointsList;let i=index" >
            <li [ngClass]="{'active': i === currentIndex}" (click)="getindex(i)" >{{app.endpointName}}
 
             <div class="edDel">                
            <button  mat-icon-button color="basic" (click)="updateAPIEndPoint(updateEndPoint,app)" class="ml-auto" matTooltip="Edit API End Point" matTooltipClass="tooltip"><mat-icon>edit_square</mat-icon></button>
  
            <button  mat-icon-button (click)="deleteThirdPartyApiEndpoints(app)"> <mat-icon>delete</mat-icon></button>
              </div>
            </li>
          </ng-container>
           
 
        
        </ul>
      </div>
      <div class="new-datatable">       
        <p>
          Mapping will appear in in offices not in, Super Admin
        </p>
        <!-- <div class="table">
          <table>
            <thead>
              <th width="90px"> Sr. No.</th>
              <th width="130px">
                <div class="inline-items-custom">
                  <mat-checkbox color="primary"></mat-checkbox>
                  Import <i class="fa fa-info-circle" matTooltip="Only selected column header will be import"></i><br>
                </div>
              </th>
              <th>Column Header From File</th>
              <th>System Fields</th>
            </thead>
            <tbody>
              <tr>
                <td>f1</td>
                <td>
                  <div class="has-checkbox">
                    <mat-checkbox color="primary"></mat-checkbox>
                  </div>
                </td>
                <td>Name</td>
                <td>
                  <mat-form-field>
                    <mat-label>Choose fields</mat-label>
                    <mat-select class="custom-select-style">
                      <mat-option [value]="1">1</mat-option>
                      <mat-option value="1">2</mat-option>
                    </mat-select>
                  </mat-form-field>
  
                </td>
              </tr>
            </tbody>
          </table>
        </div> -->
      </div>
    </mat-card>

    <!-- <button  *ngIf="!ShowSuperAdmin" [disabled]="!isFieldChanged" mat-flat-button color="primary" class="saveMapping" (click)="AddFieldMapping()">Save</button>
        -->
    <mat-card *ngIf="!ShowSuperAdmin &&  thirdPartyOfficeApiEndpointsList.length>0" class="apiListHolder">
      <div class="allApi">
        <ul>
          <ng-container>
            <li [ngClass]="{'active': i === currentIndex}"   *ngFor="let app of thirdPartyOfficeApiEndpointsList;let i=index">
            <div (click)="fieldLostPopup(fieldLostWarningPopup,2,app,i)">
              {{app.endpointName}}
            </div>
              <div class="edDel">              
               <button  mat-icon-button (click)="deleteThirdPartyOfficeApiEndpoints(app)"> <mat-icon>delete</mat-icon></button>
            </div>
            </li>
          </ng-container>
                 
        </ul>
      </div>
  
      <div class="new-datatable">      
  
        
    <div class="mapHeading">
      <h2>Select module to map the fields</h2>
      <mat-form-field>
        <mat-label>Choose Module</mat-label>
        <mat-select [(ngModel)]="DefaultFolderIdDontUSeInAPIcall"  class="custom-select-style"   (selectionChange)="fieldLostPopup(fieldLostWarningPopup,1,$event,1000)" >               
          <mat-option  *ngFor="let link of menuModulesList" [value]="link.folderID">
          {{ link.orgModuleName }}
          </mat-option>
        </mat-select>
      </mat-form-field> 
    </div>

        <div class="table">
          <table>
            <thead>
              <th width="90px"> Sr. No.</th>              
              <th>Column Header From API</th>
              <th>System Fields</th>
            </thead>
            <tbody>
              <tr  *ngFor="let mft of mappingFieldsThridParty;let i = index">
                <td>{{i+1}}</td>
               
                <td>{{mft.ApiFieldName}}</td>
                <td>
                  <mat-form-field>
                    <mat-label>Choose fields</mat-label>
                    <mat-select [(ngModel)]="mft.OfficeFieldID" [attr.value]="mft.OfficeFieldID" class="custom-select-style"   (selectionChange)="selectFeildProperty($event,mft)" >               
                      <mat-option *ngFor="let pro of Feildproperty" [value]="pro.fieldID">
                      {{ pro.fieldName }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <button  *ngIf="!ShowSuperAdmin" [disabled]="!isFieldChanged" mat-flat-button color="primary" class="saveMapping" (click)="AddFieldMapping()">Save</button>  
        
      </div>
    </mat-card>
  
    
   
    <span *ngIf="!ShowSuperAdmin &&  thirdPartyOfficeApiEndpointsList.length==0">
    Choose and add endpoint to map fields.
    </span>
  
  </div>
  

  <ng-template  #myDialog>   
  <ng-container *ngIf="!ShowSuperAdmin">
    <h2 mat-dialog-title *ngIf="thirdPartyApiName=='PointClickCare'">
      Enter PointClickCare Organization ID
      <button mat-icon-button (click)="closeAuth()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>
    <h2 mat-dialog-title *ngIf="thirdPartyApiName!='PointClickCare'">
      Request Access
      <button mat-icon-button (click)="closeAuth()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <!-- <mat-form-field class="example-full-width">
        <mat-label>Grant Type</mat-label>
        <input type="text" matInput placeholder="Add grant type" [(ngModel)]="granttype"/>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Client Id</mat-label>
        <input type="text" matInput placeholder="Add client Id" [(ngModel)]="clientId"/>
      </mat-form-field>  
      <mat-form-field class="example-full-width">
        <mat-label>Client Secret</mat-label>
        <input type="text" matInput placeholder="Add client secret" [(ngModel)]="clientsecret"/>
      </mat-form-field> 
      <mat-form-field class="example-full-width">
        <mat-label>UserName</mat-label>
        <input type="text" matInput placeholder="Add user name" [(ngModel)]="username"/>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Password</mat-label>
        <input type="text" matInput placeholder="Add password" [(ngModel)]="password"/>
      </mat-form-field>  -->
      <mat-form-field class="example-full-width">
        <mat-label *ngIf="thirdPartyApiName=='PointClickCare'">Organization ID</mat-label>
        <mat-label *ngIf="thirdPartyApiName!='PointClickCare'">Display Id</mat-label>
        <input type="text" matInput  *ngIf="thirdPartyApiName=='PointClickCare'" placeholder="Add Organization ID" [(ngModel)]="displayId"/>
        <input type="text" matInput *ngIf="thirdPartyApiName=='Paychex'" placeholder="Add displayId" [(ngModel)]="displayId"/>
      
      </mat-form-field> 
      <mat-form-field *ngIf="thirdPartyApiName=='PointClickCare'" class="example-full-width">
        <mat-label *ngIf="thirdPartyApiName=='PointClickCare'">Facility ID</mat-label>
        <input type="text" matInput  *ngIf="thirdPartyApiName=='PointClickCare'" placeholder="Add Facility ID" [(ngModel)]="facilityID"/>
        
      </mat-form-field>
      <!-- <mat-form-field class="example-full-width">
        <mat-label>Company Id</mat-label>
        <input type="text"  readonly matInput placeholder="companyId" [(ngModel)]="companyId"/>
      </mat-form-field>  -->
    </mat-dialog-content>
    
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeAuth()">Cancel</button>
      <button mat-flat-button color="primary" *ngIf="thirdPartyApiName=='PointClickCare'" (click)="authenticate(approvalLinkPopup)"
       [disabled]="Showauthenticate">
       Save
        <mat-icon *ngIf="spinnerauthenticate"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
      <button mat-flat-button color="primary" *ngIf="thirdPartyApiName!='PointClickCare'" (click)="authenticate(approvalLinkPopup)"
      [disabled]="Showauthenticate">
      Request Access
       <mat-icon *ngIf="spinnerauthenticate"><mat-spinner diameter="20">
       </mat-spinner></mat-icon>
     </button>
    </mat-dialog-actions>
  </ng-container>
  <ng-container *ngIf="ShowSuperAdmin">
    <h2 mat-dialog-title>
      Add/Edit API Credentials
      <button mat-icon-button (click)="closeAuth1()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">
      <mat-form-field class="example-full-width">
        <mat-label>Grant Type</mat-label>
        <input type="text" matInput placeholder="Add grant type" [(ngModel)]="granttype"/>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Client Id</mat-label>
        <input type="text" matInput placeholder="Add client Id" [(ngModel)]="clientId"/>
      </mat-form-field>  
      <mat-form-field class="example-full-width">
        <mat-label>Client Secret</mat-label>
        <input type="text" matInput placeholder="Add client secret" [(ngModel)]="clientsecret"/>
      </mat-form-field> 
      <!-- <mat-form-field class="example-full-width">
        <mat-label>UserName</mat-label>
        <input type="text" matInput placeholder="Add user name" [(ngModel)]="username"/>
      </mat-form-field>
      <mat-form-field class="example-full-width">
        <mat-label>Password</mat-label>
        <input type="text" matInput placeholder="Add password" [(ngModel)]="password"/>
      </mat-form-field> 
      <mat-form-field class="example-full-width">
        <mat-label>Company Id</mat-label>
        <input type="text" matInput placeholder="Add companyId" [(ngModel)]="companyId"/>
      </mat-form-field>  -->
    </mat-dialog-content>
    
    <mat-dialog-actions class="dialog-actions">
      <button mat-button (click)="closeAuth1()">Cancel</button>
      <button mat-flat-button color="primary" (click)="AddEditAPISuperAdmincrendentials()"
       [disabled]="Showauthenticate">
        Save
        <mat-icon *ngIf="spinnerauthenticate"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
      </button>
    </mat-dialog-actions>
  </ng-container>

</ng-template>

  
  
  <ng-template #addNew>
    <form  [formGroup]="formDialog">
      <h2 mat-dialog-title>
        Add 3rd party application
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
      <mat-dialog-content class="mat-typography">

        <mat-card class="logoName">
          <div class="upDoc ">
            <div class="uploadholder">

              <div class="uploadedData">
                <img *ngIf="ImageUploadURL!=''" src="{{ ImageUploadURL }}" alt="" />              
              </div>  

              <input type="file" alt="" class="form-control" accept="image/*"
               (change)="onSelectFile($event)" />
                          
              <div class="textIn">
                <p>Upload Logo</p>
              </div>
            </div>
          </div> 

        <div class="detailapi">

          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Application Name</mat-label>
            <input matInput placeholder="Enter application name" formControlName="applicationName"/>
            <mat-error
            *ngIf="formDialog.get('applicationName').invalid &&
              (formDialog.get('applicationName').dirty ||
              formDialog.get('applicationName').touched)">
            <span>This field is mandatory.</span>
          </mat-error>
          </mat-form-field>
  
  
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Description</mat-label>
            <textarea matInput placeholder="write some description" formControlName="applicationDescription"></textarea>
            <mat-error
            *ngIf="formDialog.get('applicationDescription').invalid &&
              (formDialog.get('applicationDescription').dirty ||
              formDialog.get('applicationDescription').touched)">
            <span>This field is mandatory.</span>
          </mat-error>

          </mat-form-field>


        </div>
      </mat-card>


        <mat-form-field class="example-full-width">
          <mat-label>Add Base URL</mat-label>
          <input matInput placeholder="Enter api base url"  formControlName="applicationurllogo"/>
          <mat-error
          *ngIf="formDialog.get('applicationurllogo').invalid &&
            (formDialog.get('applicationurllogo').dirty ||
            formDialog.get('applicationurllogo').touched)">
          <span>This field is mandatory.</span>
        </mat-error>

        </mat-form-field>

        <mat-form-field class="example-full-width">
          <mat-label>Add Authentication URL</mat-label>
          <input matInput placeholder="Enter authentication url"  formControlName="authenticationurl"/>
          <mat-error
          *ngIf="formDialog.get('authenticationurl').invalid &&
            (formDialog.get('authenticationurl').dirty ||
            formDialog.get('authenticationurl').touched)">
          <span>This field is mandatory.</span>
        </mat-error>
      </mat-form-field>

        <mat-form-field class="example-full-width">
          <mat-label>API Documentation Url</mat-label>
          <input matInput placeholder="Enter api base url" formControlName="apiDocumentationUrl" />

          <mat-error
          *ngIf="formDialog.get('apiDocumentationUrl').invalid &&
            (formDialog.get('apiDocumentationUrl').dirty ||
            formDialog.get('apiDocumentationUrl').touched)">
          <span>This field is mandatory.</span>
        </mat-error>

        </mat-form-field>            

      </mat-dialog-content>
  
      <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty" 
        (click)="AddThirdPartyApplication(formDialog.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
       </button>
      </mat-dialog-actions>
  
    </form>
  </ng-template>


  <ng-template #updateNew>
    <form  [formGroup]="formDialog">
      <h2 mat-dialog-title>
        Update 3rd party application
        <button mat-icon-button (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
      <mat-dialog-content class="mat-typography">

        <mat-card class="logoName">
          <div class="upDoc ">
            <div class="uploadholder">

              <div class="uploadedData">
                <img *ngIf="ImageUploadURL!=''" src="{{ ImageUploadURL }}" alt="" />              
              </div>  

              <input type="file" alt="" class="form-control" accept="image/*"
               (change)="onSelectFile($event)" />
           
             
              <div class="textIn">
                <p>Upload Logo</p>
              </div>
            </div>
          </div> 

        <div class="detailapi">

          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Application Name</mat-label>
            <input matInput placeholder="Enter application name" formControlName="applicationName"/>
            <mat-error
            *ngIf="formDialog.get('applicationName').invalid &&
              (formDialog.get('applicationName').dirty ||
              formDialog.get('applicationName').touched)">
            <span>This field is mandatory.</span>
          </mat-error>
          </mat-form-field>
  
  
          <mat-form-field class="example-full-width" appearance="fill">
            <mat-label>Description</mat-label>
            <textarea matInput placeholder="write some description" formControlName="applicationDescription"></textarea>
            <mat-error
            *ngIf="formDialog.get('applicationDescription').invalid &&
              (formDialog.get('applicationDescription').dirty ||
              formDialog.get('applicationDescription').touched)">
            <span>This field is mandatory.</span>
          </mat-error>

          </mat-form-field>


        </div>
      </mat-card>


        <mat-form-field class="example-full-width">
          <mat-label>Add Base URL</mat-label>
          <input matInput placeholder="Enter api base url"  formControlName="applicationurllogo"/>
          <mat-error
          *ngIf="formDialog.get('applicationurllogo').invalid &&
            (formDialog.get('applicationurllogo').dirty ||
            formDialog.get('applicationurllogo').touched)">
          <span>This field is mandatory.</span>
        </mat-error>

        </mat-form-field>


        <mat-form-field class="example-full-width">
          <mat-label>Add Authentication URL</mat-label>
          <input matInput placeholder="Enter authentication url"  formControlName="authenticationurl"/>
          <mat-error
          *ngIf="formDialog.get('authenticationurl').invalid &&
            (formDialog.get('authenticationurl').dirty ||
            formDialog.get('authenticationurl').touched)">
          <span>This field is mandatory.</span>
        </mat-error>

        </mat-form-field>

        <mat-form-field class="example-full-width">
          <mat-label>API Documentation Url</mat-label>
          <input matInput placeholder="Enter api base url" formControlName="apiDocumentationUrl" />

          <mat-error
          *ngIf="formDialog.get('apiDocumentationUrl').invalid &&
            (formDialog.get('apiDocumentationUrl').dirty ||
            formDialog.get('apiDocumentationUrl').touched)">
          <span>This field is mandatory.</span>
        </mat-error>

        </mat-form-field>
        
      
      </mat-dialog-content>
  
      <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty" 
        (click)="UpdateThirdPartyApplication(formDialog.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
       </button>
      </mat-dialog-actions>
  
    </form>
  </ng-template>

  
  
  <ng-template #addEndPoint>
    <form  [formGroup]="formDialogForAPIEndPoint">
      <h2 mat-dialog-title>
        Add API End Point
        <button mat-icon-button (click)="closeAPIEndPoint()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
      <mat-dialog-content class="mat-typography">
        
         <div class="apiHolder">
            <div class="apiType">

              <mat-form-field appearance="fill" class="type">
                <mat-label>API Type</mat-label>
                <mat-select formControlName="method">
                  <mat-option value="GET">GET</mat-option>
                  <mat-option value="POST">POST</mat-option>
                  <mat-option value="DELETE">DELETE</mat-option>
                  <mat-option value="PATCH">PATCH</mat-option>
                </mat-select>
              </mat-form-field>
    
    
              <mat-form-field class="mlr-15" appearance="outline">
                <mat-label>End Point Name</mat-label>
                <input matInput placeholder="Enter end point name" formControlName="endpointName"/>
              </mat-form-field>
    
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>End Point Url</mat-label>
                <input matInput placeholder="Enter end point url" formControlName="endpointUrl"/>
              </mat-form-field>    
    
            </div>    
         
            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Request Json</mat-label>
              <textarea matInput placeholder="Enter request json" formControlName="requestModel"></textarea>
            </mat-form-field> 

            <mat-form-field class="example-full-width" appearance="outline">
              <mat-label>Response Json</mat-label>
              <textarea matInput placeholder="Enter Response json" formControlName="responseModel"></textarea>
            </mat-form-field> 

          </div> 


      </mat-dialog-content>
  
      <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="closeAPIEndPoint()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="formDialogForAPIEndPoint.invalid || !formDialogForAPIEndPoint.dirty" 
        (click)="AddThirdPartyApiEndpoint(formDialogForAPIEndPoint.value)">
        Add
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
       </button>
      </mat-dialog-actions>
  
    </form>
  </ng-template>


  <ng-template #updateEndPoint>
    <form  [formGroup]="formDialogForAPIEndPoint">
      <h2 mat-dialog-title>
        Update API End Point
        <button mat-icon-button (click)="closeAPIEndPoint()">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
      <mat-dialog-content class="mat-typography">
        
         <div class="apiHolder">
            <div class="apiType">

              <mat-form-field appearance="outline" class="type">
                <mat-label>API Type</mat-label>
                <mat-select formControlName="method">
                  <mat-option value="GET">GET</mat-option>
                  <mat-option value="POST">POST</mat-option>
                  <mat-option value="DELETE">DELETE</mat-option>
                  <mat-option value="PATCH">PATCH</mat-option>
                </mat-select>
              </mat-form-field>
    
    
              <mat-form-field class="mlr-15" appearance="outline">
                <mat-label>End Point Name</mat-label>
                <input matInput placeholder="Enter end point name" formControlName="endpointName"/>
              </mat-form-field>
    
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>End Point Url</mat-label>
                <input matInput placeholder="Enter end point url" formControlName="endpointUrl"/>
              </mat-form-field>    
    
            </div>    
         
            <mat-form-field class="reqJson" appearance="fill">
              <mat-label>Request Json</mat-label>
              <textarea matInput placeholder="Enter request json" formControlName="requestModel"></textarea>
            </mat-form-field> 

            <mat-form-field class="reqJson" appearance="fill">
              <mat-label>Response Json</mat-label>
              <textarea matInput placeholder="Enter Response json" formControlName="responseModel"></textarea>
            </mat-form-field> 

          </div> 


      </mat-dialog-content>
  
      <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="closeAPIEndPoint()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="formDialogForAPIEndPoint.invalid || !formDialogForAPIEndPoint.dirty" 
        (click)="UpdateThirdPartyApiEndpoint(formDialogForAPIEndPoint.value)">
        Update
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
       </button>
      </mat-dialog-actions>
  
    </form>
  </ng-template>

  <ng-template #fieldLostWarningPopup>
      <h2 mat-dialog-title>
        Warning
        <button mat-icon-button (click)="closeFieldLostWarningPopup(1)">
          <mat-icon>close</mat-icon>
        </button>
      </h2>
  
      <mat-dialog-content class="mat-typography">

      <span>Please save field mapping otherwise mapping will be lost.</span>
      </mat-dialog-content>
  
      <mat-dialog-actions class="dialog-actions">
        <button mat-button (click)="closeFieldLostWarningPopup(1)">Cancel</button>
        <button mat-flat-button color="primary"
        (click)="WaringProceed()">
        Proceed
        <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
        </mat-spinner></mat-icon>
       </button>
      </mat-dialog-actions>
  </ng-template>
  <ng-template #approvalLinkPopup>
    <h2 mat-dialog-title>
      Paychex Approval link
      <button mat-icon-button (click)="closeFieldLostWarningPopup()">
        <mat-icon>close</mat-icon>
      </button>
    </h2>

    <mat-dialog-content class="mat-typography">

    <span>Please copy and use below Paychex approval link to provide access of your company to Flowtrics.</span>
    <br>
    <br>
    <a href="{{approvalLink}}" target="_blank" class="accessLink">Click here or copy link from below to provide access.</a>

    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions moveRight">
      
    <button mat-icon-button color="primary" [cdkCopyToClipboard]="approvalLink" > <mat-icon>content_copy</mat-icon> </button>
    </mat-dialog-actions>
</ng-template>

<ng-template #GetFacilitiespopup>
  <h2 mat-dialog-title>
    Facilities List
    <button mat-icon-button (click)="closeFacilities()">
      <mat-icon>close</mat-icon>
    </button>
  </h2>

  <mat-dialog-content class="mat-typography">
    <ng-container *ngFor="let app of facilitiesList">
    <span >Facility ID: {{app.facId}},  Facility Name: {{app.facilityName}}</span><br>
   </ng-container>
  </mat-dialog-content>

</ng-template>

  <app-loader></app-loader>